module.exports = __webpack_public_path__ + "static/media/0198_Medium.db51da99.jpg";